export default "__VITE_ASSET__9OdfsD8Y__"